var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMention(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon _mention"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M25.913 147.506a10 10 0 1 1 9.987-10c0 1.548-.866 4.542-4.141 4.8a3.924 3.924 0 0 1-3.372-1.509 4.88 4.88 0 0 1-3.866 2.018 4.009 4.009 0 0 1-2.989-1.407l-.07-.092a5.371 5.371 0 0 1-.614-4.721 7.081 7.081 0 0 1 1.309-2.668 4.6 4.6 0 0 1 2.814-1.675 4.209 4.209 0 0 1 2.816.627 1.011 1.011 0 0 1 1.02-.752 1 1 0 0 1 .949 1.048c-.03.579-.04 1.141-.051 1.711-.017.91-.035 1.852-.128 2.913a4.4 4.4 0 0 0 .09 1.209 1.877 1.877 0 0 0 1.94 1.3c2.2-.173 2.29-2.54 2.293-2.809a8 8 0 1 0-3.27 6.459 1 1 0 1 1 1.182 1.614 9.94 9.94 0 0 1-5.899 1.934zm-2.823-7.356a2.01 2.01 0 0 0 1.463.662c1.615.061 2.877-1.627 3.028-3.144q.009-.227.021-.441c.057-1.1.061-1.753-.538-2.372a2.129 2.129 0 0 0-1.794-.626 2.58 2.58 0 0 0-1.544.937 5.094 5.094 0 0 0-.947 1.951l-.029.1a3.361 3.361 0 0 0 .34 2.934z",
    transform: "translate(-15.9 -127.506)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMention);
export default __webpack_public_path__ + "static/media/icon-mention.15ab3482f1dc286418d9c888ce2f5f3a.svg";
export { ForwardRef as ReactComponent };